var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"track",class:_vm.trackClass,style:({
    height: _vm.computedHeight,
  })},[_c('div',{staticClass:"indicator",class:_vm.indicatorClass,style:({
      width: `${_vm.value}%`,
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }